export const TOOL_TYPE = {
  D3_VISUALIZATION: 'd3_visualization',
  MERMAID_DIAGRAM: 'mermaid_diagram',
  CONTENT_REFERENCES: 'content_references',
  GEOGEBRA_VISUALIZATION: 'geogebra_visualization',
  THREEJS_VISUALIZATION: 'threejs_visualization',
  WEB_SEARCH: 'web_search',
  IMAGE: 'image',
  CANVAS_GENERATION: 'canvas_generation',
};
